import styled from "styled-components";
import { theme } from "../../../constants/StyledComponents";

export const StyledPotentialMatrixTabLayout = styled.div<{
  $hideScroll?: boolean;
}>`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: ${({ $hideScroll }) => ($hideScroll ? "hidden" : "auto")};
  height: calc(100dvh - 136px);
`;

export const StyledPotentialMatrixTabFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  height: 72px;
  border-top: 1px solid ${theme.colors.purple_2};
  padding: 0 20px;
`;

export const StyledPotentialMatrixTabContent = styled.div<{
  $hideScroll?: boolean;
}>`
  height: 100%;
  flex-direction: column;
  display: flex;
  padding: 20px;
  overflow-y: ${({ $hideScroll }) => ($hideScroll ? "hidden" : "auto")};
  gap: 20px;
`;
